<template>
	<v-container fluid pa-0 fill-height>
		<v-card fill-height flat style="width: 100%;height:100%;">
			<v-card-text class="pa-0 d-flex flex-column justify-space-between" style="height:100%;">
				<div class="card-header d-flex justify-space-between align-center">
					<div class="header-content">
						<div class="icon-wrapper">
							<v-icon small color="white">{{ titleIcon }}</v-icon>
						</div>
						<div class="title-section">
							<h3 class="card-title">{{ title }}</h3>
							<div class="title-underline"></div>
						</div>
					</div>
					<GlobalNewButton />
				</div>
				<div :class="showWeeklyTable ? 'px-3 py-0' : 'pa-3'">
					<!-- Loading state -->
					<v-row class="project-detail-card" v-if="!dashboardData" dense>
						<v-col cols="12" md="6" class="pr-md-2">
							<v-skeleton-loader type="list-item" class="mb-1"></v-skeleton-loader>
							<v-skeleton-loader type="list-item" class="mb-1"></v-skeleton-loader>
							<v-skeleton-loader type="list-item"></v-skeleton-loader>
						</v-col>
						<v-col cols="12" md="6" class="pl-md-2">
							<v-skeleton-loader type="avatar@3" ></v-skeleton-loader>
						</v-col>
					</v-row>
					<!-- Métricas superiores y gráficos circulares -->
					<v-row class="project-detail-card" v-else-if="!showWeeklyTable" dense @click="$emit('goToListing')" style="cursor: pointer;">
						<!-- Métricas izquierda -->
						<v-col cols="12" md="6" class="pr-md-2">
							<!-- Métrica 1 -->
							<div class="metric-card mb-1">
								<div class="d-flex align-center">
									<div class="metric-icon-wrapper" :class="dashboardData.metric1Trend === 'up' ? 'trend-up' : 'trend-down'">
										<v-icon x-small color="white">
											{{ dashboardData.metric1Trend === 'up' ? 'mdi-trending-up' : 'mdi-trending-down' }}
										</v-icon>
									</div>
									<div class="flex-grow-1">
										<p class="metric-label-new mb-0">{{ config.metric1Label }}</p>
										<p class="metric-value-new mb-0">{{ dashboardData.metric1Value }} <span class="metric-unit-new">{{ config.metric1Unit }}</span></p>
									</div>
								</div>
							</div>

							<!-- Métrica 2 -->
							<div class="metric-card mb-1">
								<div class="d-flex align-center">
									<div class="metric-icon-wrapper" :class="dashboardData.metric2Trend === 'up' ? 'trend-up' : 'trend-down'">
										<v-icon x-small color="white">
											{{ dashboardData.metric2Trend === 'up' ? 'mdi-trending-up' : 'mdi-trending-down' }}
										</v-icon>
									</div>
									<div class="flex-grow-1">
										<p class="metric-label-new mb-0">{{ config.metric2Label }}</p>
										<p class="metric-value-new mb-0">{{ dashboardData.metric2Value }} <span class="metric-unit-new">{{ config.metric2Unit }}</span></p>
									</div>
								</div>
							</div>

							<!-- Métrica 3 -->
							<div class="metric-card">
								<div class="d-flex align-center">
									<div class="metric-icon-wrapper" :class="dashboardData.metric3Trend === 'up' ? 'trend-up' : 'trend-down'">
										<v-icon x-small color="white">
											{{ dashboardData.metric3Trend === 'up' ? 'mdi-trending-up' : 'mdi-trending-down' }}
										</v-icon>
									</div>
									<div class="flex-grow-1">
										<p class="metric-label-new mb-0">{{ config.metric3Label }}</p>
										<p class="metric-value-new mb-0">{{ dashboardData.metric3Value }} <span class="metric-unit-new">{{ config.metric3Unit }}</span></p>
									</div>
								</div>
							</div>
						</v-col>

						<!-- Gráficos circulares derecha -->
						<v-col cols="12" md="6" class="pl-md-2 d-flex align-center">
							<v-row dense class="flex-grow-1">
								<!-- Total -->
								<v-col cols="4" class="text-center px-1">
									<div class="chart-wrapper-sm">
										<DoughnutChart
											:chartdata="{
												datasets: [{
													backgroundColor: [config.chart1Color, '#F5F5F5'],
													data: [dashboardData.chart1Total, dashboardData.chart1Total * 0.1],
													borderWidth: 0
												}]
											}"
											:options="getChartOptions(dashboardData.chart1Total)"
										/>
									</div>
										<p class="chart-label-sm mb-0" :style="{ color: config.chart1Color }">{{ config.chart1Label }}</p>
								</v-col>
								<!-- Resolved -->
								<v-col cols="4" class="text-center px-1">
									<div class="chart-wrapper-sm">
										<DoughnutChart
											:chartdata="{
												datasets: [{
													backgroundColor: [config.chart2Color, '#F5F5F5'],
													data: [dashboardData.chart2Resolved, dashboardData.chart1Total - dashboardData.chart2Resolved],
													borderWidth: 0
												}]
											}"
											:options="getChartOptions(dashboardData.chart2Resolved)"
										/>
									</div>
										<p class="chart-label-sm mb-0" :style="{ color: config.chart2Color }">{{ config.chart2Label }}</p>
								</v-col>
								<!-- Pending -->
								<v-col cols="4" class="text-center px-1">
									<div class="chart-wrapper-sm">
										<DoughnutChart
											:chartdata="{
												datasets: [{
													backgroundColor: [config.chart3Color, '#F5F5F5'],
													data: [dashboardData.chart3Pending, dashboardData.chart1Total - dashboardData.chart3Pending],
													borderWidth: 0
												}]
											}"
											:options="getChartOptions(dashboardData.chart3Pending)"
										/>
									</div>
										<p class="chart-label-sm mb-0" :style="{ color: config.chart3Color }">{{ config.chart3Label }}</p>
								</v-col>
							</v-row>
						</v-col>
					</v-row>

					<!-- Loading state - Weekly chart -->
					<v-divider class="my-2" v-if="!dashboardData"></v-divider>
					<v-row class="project-detail-card" v-if="!dashboardData" dense>
						<v-col cols="12">
							<v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
							<v-skeleton-loader type="image" height="120"></v-skeleton-loader>
						</v-col>
					</v-row>

					<!-- Resumen Semanal Compacto -->
					<v-divider class="my-2" v-if="!showWeeklyTable"></v-divider>

					<v-row class="project-detail-card" v-if="dashboardData" dense>
						<v-col cols="12">
							<div class="d-flex align-center justify-space-between mb-0">
								<span class="section-title-sm">
									<v-icon x-small class="mr-1">mdi-chart-line</v-icon>
									{{ config.weeklySummaryTitle }}
								</span>
								<v-btn
									x-small
									text
									color="#2D4B95"
									@click="showWeeklyTable = !showWeeklyTable"
									class="toggle-table-btn"
								>
									<v-icon x-small class="mr-1">
										{{ showWeeklyTable ? 'mdi-table-remove' : 'mdi-table-eye' }}
									</v-icon>
									{{ showWeeklyTable ? 'Ocultar tabla' : 'Ver tabla' }}
								</v-btn>
							</div>

							<BarChart
								ref="weeklyChart"
								class="weekliy-chart"
								:height="120"
								:chartdata="weeklyChartData"
								:options="weeklyChartOptions"
							/>

							<!-- Tabla de datos semanales -->
							<v-expand-transition>
								<div v-show="showWeeklyTable" class="data-table-wrapper mt-0" :style="tableWrapperStyle">
								<table class="weekly-data-table" style="table-layout: fixed;">
									<colgroup v-if="labelColWidth">
										<col :style="{ width: labelColWidth + 'px' }">
										<col v-for="i in numDataCols" :key="i" :style="{ width: dataColWidth + 'px' }">
									</colgroup>
										<tbody>
											<!-- Sección Parcial -->
											<tr>
													<td class="row-label" :style="[rowLabelStyle, { color: config.chart1Color }]">
													<span class="section-inline-label">Parcial</span>
													{{ config.tableRow1Label }}
												</td>
												<td style="width: 34px;" v-for="(value, index) in weeklyDataNormalized.data1" :key="'d1-'+index">{{ value }}</td>
											</tr>
												<tr class="section-separator">
													<td class="row-label" :style="[rowLabelStyle, { color: config.chart2Color }]">{{ config.tableRow3Label }}</td>
													<td v-for="(value, index) in weeklyDataNormalized.data3" :key="'d3-'+index">{{ value }}</td>
												</tr>
											<!-- Sección Acumulada -->
											<tr>
												<td class="row-label" :style="[rowLabelStyle, { color: config.chart1Color }]">
													<span class="section-inline-label">Acumulado</span>
													{{ config.tableRow1Label }}
												</td>
												<td v-for="(value, index) in weeklyDataNormalized.data1_acc" :key="'a1-'+index">{{ value }}</td>
											</tr>
											<tr>
												<td class="row-label" :style="[rowLabelStyle, { color: config.chart2Color }]">{{ config.tableRow3Label }}</td>
												<td v-for="(value, index) in weeklyDataNormalized.data3_acc" :key="'a3-'+index">{{ value }}</td>
											</tr>
											<tr class="last-row">
												<td class="row-label" :style="[rowLabelStyle, { color: config.chart3Color }]">{{ config.tableRow2Label }}</td>
												<td v-for="(value, index) in weeklyDataNormalized.data2_acc" :key="'a2-'+index">{{ value }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</v-expand-transition>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import DoughnutChart from '@/components/Charts/Doughnut'
import BarChart from '@/components/Charts/Bar'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
// import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'

const CONFIG_BY_TYPE = {
	additional: {
		metric1Label: 'Prom. Adicionales/Sem',
		metric1Unit: 'adicionales',
		metric2Label: 'Prom. Soluciones/Sem',
		metric2Unit: 'adicionales',
		metric3Label: 'Tiempo Prom. Adicional',
		metric3Unit: 'días',
		chart1Label: 'TOTAL',
		chart1Color: '#EAB261',
		chart2Label: 'RESUELTAS',
		chart2Color: '#34BFA3',
		chart3Label: 'PENDIENTES',
		chart3Color: '#F45771',
		weeklySummaryTitle: 'Resumen Semanal',
		weeklyBar1Label: 'Creadas',
		weeklyBar2Label: 'Pendientes',
		weeklyBar3Label: 'Resueltas',
		weeklyAccLine1Label: 'Creadas Acum.',
		weeklyAccLine2Label: 'Resueltas Acum.',
		weeklyAccLine3Label: 'Pendientes Acum.',
		tableRow1Label: 'Creadas',
		tableRow2Label: 'Pendientes',
		tableRow3Label: 'Resueltas'
	},
	task: {
		metric1Label: 'Prom. Tareas/Sem',
		metric1Unit: 'tareas',
		metric2Label: 'Prom. Resueltas/Sem',
		metric2Unit: 'tareas',
		metric3Label: 'Tiempo Prom. Tarea',
		metric3Unit: 'días',
		chart1Label: 'TOTAL',
		chart1Color: '#EAB261',
		chart2Label: 'RESUELTAS',
		chart2Color: '#34BFA3',
		chart3Label: 'PENDIENTES',
		chart3Color: '#F45771',
		weeklySummaryTitle: 'Resumen Semanal',
		weeklyBar1Label: 'Creadas',
		weeklyBar2Label: 'Pendientes',
		weeklyBar3Label: 'Resueltas',
		weeklyAccLine1Label: 'Creadas Acum.',
		weeklyAccLine2Label: 'Resueltas Acum.',
		weeklyAccLine3Label: 'Pendientes Acum.',
		tableRow1Label: 'Creadas',
		tableRow2Label: 'Pendientes',
		tableRow3Label: 'Resueltas'
	},
	rdi: {
		metric1Label: 'Prom. RDI/Sem',
		metric1Unit: 'rdis',
		metric2Label: 'Prom. Resueltos/Sem',
		metric2Unit: 'rdis',
		metric3Label: 'Tiempo Prom. RDI',
		metric3Unit: 'días',
		chart1Label: 'TOTAL',
		chart1Color: '#EAB261',
		chart2Label: 'RESUELTOS',
		chart2Color: '#34BFA3',
		chart3Label: 'PENDIENTES',
		chart3Color: '#F45771',
		weeklySummaryTitle: 'Resumen Semanal',
		weeklyBar1Label: 'Creados',
		weeklyBar2Label: 'Pendientes',
		weeklyBar3Label: 'Resueltos',
		weeklyAccLine1Label: 'Creados Acum.',
		weeklyAccLine2Label: 'Resueltos Acum.',
		weeklyAccLine3Label: 'Pendientes Acum.',
		tableRow1Label: 'Creados',
		tableRow2Label: 'Pendientes',
		tableRow3Label: 'Resueltos'
	}
}

export default {
	name: 'ProjectDetailCard',
	components: { DoughnutChart, BarChart, GlobalNewButton },
	props: {
		type: {
			type: String,
			required: true,
			validator: (value) => ['additional', 'task', 'rdi'].includes(value)
		},
		data: {
			type: Object,
			default: null
		}
	},
	data: () => ({
		showWeeklyTable: false,
		dashboardData: null,
		labelColWidth: 0,
		dataColWidth: 0,
		numDataCols: 0,
		tableRightPad: 0
	}),
	computed: {
		config() {
			return CONFIG_BY_TYPE[this.type] || CONFIG_BY_TYPE.additional
		},
		title() {
			switch (this.type) {
				case 'additional': return 'Adicionales'
				case 'task': return 'Tareas'
				case 'rdi': return 'RDI'
				default: return 'Métricas'
			}
		},
		titleIcon() {
			switch (this.type) {
				case 'additional': return 'mdi-file-document-plus-outline'
				case 'task': return 'mdi-clipboard-check-outline'
				case 'rdi': return 'mdi-file-chart-outline'
				default: return 'mdi-chart-box-outline'
			}
		},
		weeklyDataNormalized() {
			const wd = (this.dashboardData && this.dashboardData.weeklyData) || {}
			const labels = wd.labels || []
			const toNum = v => (typeof v === 'number' ? v : (v ? Number(v) || 0 : 0))
			const pad = (arr) => labels.map((_, i) => toNum(arr && arr[i]))
			const data1 = pad(wd.data1 || [])
			const data3 = pad(wd.data3 || [])
			const cum = (arr) => {
				const out = []
				for (let i = 0; i < labels.length; i++) {
					const val = toNum(arr[i])
					out[i] = i === 0 ? val : out[i - 1] + val
				}
				return out
			}
			const data1_acc = (wd.data1_acc && wd.data1_acc.length === labels.length) ? pad(wd.data1_acc) : cum(data1)
			const data3_acc = (wd.data3_acc && wd.data3_acc.length === labels.length) ? pad(wd.data3_acc) : cum(data3)
			// data2_acc: pendientes acumulados = creados_acc - resueltos_acc (consistente con el backend)
			const data2_acc = (wd.data2_acc && wd.data2_acc.length === labels.length)
				? pad(wd.data2_acc)
				: data1_acc.map((v, i) => v - data3_acc[i])
			return { labels, data1, data3, data1_acc, data2_acc, data3_acc }
		},
		weeklyChartData() {
			const wd = this.weeklyDataNormalized || { labels: [], data1: [], data2: [], data3: [], data1_acc: [], data2_acc: [], data3_acc: [] }
			return {
				labels: wd.labels,
				datasets: [
					{
						type: 'bar',
						label: this.config.weeklyBar1Label,
						backgroundColor: this.config.chart1Color,
						data: wd.data1,
						barThickness: 6,
						yAxisID: 'left'
					},
					{
						type: 'bar',
						label: this.config.weeklyBar3Label,
						backgroundColor: this.config.chart2Color,
						data: wd.data3,
						barThickness: 6,
						yAxisID: 'left'
					},
					{
						type: 'line',
						label: this.config.weeklyAccLine1Label,
						borderColor: this.config.chart1Color,
						backgroundColor: 'transparent',
						data: wd.data1_acc,
						hidden: true,
						fill: false,
						pointBackgroundColor: this.config.chart1Color,
						pointBorderColor: this.config.chart1Color,
						pointRadius: 3,
						pointHoverRadius: 4,
						tension: 0.3,
						borderWidth: 2,
						yAxisID: 'right'
					},
					{
						type: 'line',
						label: this.config.weeklyAccLine2Label,
						borderColor: this.config.chart2Color,
						backgroundColor: 'transparent',
						data: wd.data3_acc,
						hidden: true,
						fill: false,
						pointBackgroundColor: this.config.chart2Color,
						pointBorderColor: this.config.chart2Color,
						pointRadius: 3,
						pointHoverRadius: 4,
						tension: 0.3,
						borderWidth: 2,
						yAxisID: 'right'
					},
					{
						type: 'line',
						label: this.config.weeklyAccLine3Label,
						borderColor: this.config.chart3Color,
						backgroundColor: 'transparent',
						data: wd.data2_acc,
						fill: false,
						pointBackgroundColor: this.config.chart3Color,
						pointBorderColor: this.config.chart3Color,
						pointRadius: 3,
						pointHoverRadius: 4,
						tension: 0.3,
						borderWidth: 2,
						yAxisID: 'right'
					}
				]
			}
		},
		weeklyChartOptions() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				layout: {
					padding: { top: 0, right: 12, left: 4, bottom: 4 }
				},
				animation: {
					onComplete: () => {
						const ref = this.$refs.weeklyChart
						if (!ref) return
						const chart = ref._chart || (ref.$data && ref.$data._chart)
						if (!chart || !chart.chartArea) return
						const { left, right } = chart.chartArea
						const w = chart.width
						const n = chart.data && chart.data.labels ? chart.data.labels.length : 0
						if (n === 0) return
						const newLabelW = Math.round(left)
						const newDataW = Math.round((right - left) / n)
						const newRightPad = Math.round(w) - newLabelW - n * newDataW
						if (this.labelColWidth !== newLabelW ||
							this.dataColWidth !== newDataW ||
							this.numDataCols !== n ||
							this.tableRightPad !== newRightPad) {
							this.labelColWidth = newLabelW
							this.dataColWidth = newDataW
							this.numDataCols = n
							this.tableRightPad = newRightPad
						}
					}
				},
				legend: {
					display: true,
					position: 'top',
					align: 'end',
					labels: {
						fontSize: 9,
						fontColor: '#2D4B95',
						fontStyle: 'bold',
						boxWidth: 10,
						padding: 6,
						usePointStyle: false
					}
				},
				tooltips: {
					mode: 'index',
					intersect: false,
					callbacks: {
						label: function(tooltipItem, data) {
							const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || ''
							return datasetLabel + ': ' + tooltipItem.yLabel
						}
					}
				},
				scales: {
					xAxes: [{
						gridLines: { display: false },
						ticks: { fontColor: '#2D4B95', fontSize: 9, fontStyle: 'bold' }
					}],
					yAxes: [
						{
							id: 'left',
							position: 'left',
							scaleLabel: { display: true, labelString: 'PARCIALES', fontColor: '#9CA3AF', fontSize: 7, fontStyle: 'bold' },
							ticks: { beginAtZero: true, maxTicksLimit: 6, fontColor: '#2D4B95', fontSize: 8, padding: 8 },
							gridLines: { color: '#E0E0E0', borderDash: [2, 2] }
						},
						{
							id: 'right',
							position: 'right',
							scaleLabel: { display: true, labelString: 'ACUMULADOS', fontColor: '#9CA3AF', fontSize: 7, fontStyle: 'bold' },
							ticks: { beginAtZero: true, maxTicksLimit: 6, fontColor: '#9CA3AF', fontSize: 8, padding: 8 },
							gridLines: { display: false }
						}
					]
				}
			}
		},
		tableWrapperStyle() {
			if (!this.showWeeklyTable || !this.labelColWidth) return {}
			return {
				paddingRight: this.tableRightPad + 'px'
			}
		},
		rowLabelStyle() {
			if (!this.labelColWidth) return {}
			return {
				width: this.labelColWidth + 'px',
				minWidth: this.labelColWidth + 'px'
			}
		}
	},
	watch: {
		showWeeklyTable(val) {
			if (val) {
				this.$nextTick(() => {
					const ref = this.$refs.weeklyChart
					if (!ref) return
					const chart = ref._chart || (ref.$data && ref.$data._chart)
					if (!chart || !chart.chartArea) return
					const { left, right } = chart.chartArea
					const w = chart.width
					const n = chart.data && chart.data.labels ? chart.data.labels.length : 0
					if (n === 0) return
					const newLabelW = Math.round(left)
					const newDataW = Math.round((right - left) / n)
					const newRightPad = Math.round(w) - newLabelW - n * newDataW
					if (this.labelColWidth !== newLabelW ||
						this.dataColWidth !== newDataW ||
						this.numDataCols !== n ||
						this.tableRightPad !== newRightPad) {
						this.labelColWidth = newLabelW
						this.dataColWidth = newDataW
						this.numDataCols = n
						this.tableRightPad = newRightPad
					}
				})
			}
		},
		data: {
			handler(newData) {
				if (newData) {
					this.dashboardData = { ...this.dashboardData, ...newData }
				}
			},
			deep: true
		}
	},
	mounted() {
		if(this.data) {
			this.dashboardData = { ...this.dashboardData, ...this.data }
		}
	},
	methods: {
		getChartOptions(value) {
			return {
				tooltips: { enabled: false },
				cutoutPercentage: 70,
				responsive: true,
				maintainAspectRatio: true,
				legend: { display: false },
				elements: {
					center: {
						text: value.toString(),
						color: '#2D4B95',
						fontStyle: 'Arial',
						sidePadding: 20,
						minFontSize: 20,
						lineHeight: 25
					}
				},
				plugins: {
					doughnutlabel: {
						labels: [{
							text: value.toString(),
							font: {
								size: 32,
								weight: 'bold'
							},
							color: '#2D4B95'
						}]
					}
				}
			}
		}
	}
}
</script>

<style scoped>
	.card-header {
		background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
		border-bottom: 2px solid #E3E8EF;
		padding: 8px 12px;
	}

	.header-content {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.icon-wrapper {
		width: 28px;
		height: 28px;
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
		flex-shrink: 0;
		background-color: #5E85EF;
	}

	.title-section {
		flex: 1;
	}

	.card-title {
		font-size: 14px;
		font-weight: 700;
		color: #2D4B95;
		margin: 0;
		line-height: 1.2;
		letter-spacing: 0.3px;
	}

	.title-underline {
		width: 32px;
		height: 2px;
		border-radius: 2px;
		margin-top: 3px;
		background-color: #5E85EF;
	}

	.project-detail-card, 
	.project-detail-card p {
		color: #2D4B95;
	}

	.metric-card {
		background: linear-gradient(135deg, #ffffff 0%, #f8f9fb 100%);
		padding: 4px 10px;
		border-radius: 6px;
		border: 1px solid #E3E8EF;
		box-shadow: 0 2px 4px rgba(45, 75, 149, 0.08);
		transition: all 0.2s ease;
	}

	.metric-card:hover {
		box-shadow: 0 4px 8px rgba(45, 75, 149, 0.12);
		transform: translateY(-1px);
	}

	.metric-icon-wrapper {
		width: 24px;
		height: 24px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 8px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
	}

	.metric-icon-wrapper.trend-up {
		background: linear-gradient(135deg, #34BFA3 0%, #2A9A83 100%);
	}

	.metric-icon-wrapper.trend-down {
		background: linear-gradient(135deg, #F45771 0%, #D14560 100%);
	}

	.metric-label-new {
		font-size: 8px;
		font-weight: 600;
		color: #6B7280;
		text-transform: uppercase;
		letter-spacing: 0.3px;
		line-height: 1.1;
	}

	.metric-value-new {
		font-size: 15px;
		font-weight: 700;
		color: #2D4B95;
		line-height: 1.1;
	}

	.metric-unit-new {
		font-size: 9px;
		font-weight: 500;
		color: #9CA3AF;
	}

	.chart-wrapper-sm {
		position: relative;
		max-width: 70px;
		margin: 0 auto;
	}

	/* Eliminar borde y sombra de canvas */
	::v-deep .chart-wrapper-sm canvas {
		border: none !important;
		box-shadow: none !important;
	}

	.chart-label-sm {
		font-size: 9px;
		font-weight: 700;
		color: #2D4B95;
		letter-spacing: 0.3px;
		margin-top: 4px;
	}

	.section-title-sm {
		color: #2D4B95;
		font-weight: 700;
		font-size: 11px;
		letter-spacing: 0.3px;
		text-transform: uppercase;
	}

	.legend-container-sm {
		display: flex;
		align-items: center;
	}

	.legend-item-sm {
		display: inline-flex;
		align-items: center;
		font-size: 10px;
		color: #2D4B95;
	}

	.legend-text {
		font-size: 9px;
		font-weight: 500;
		margin-left: 2px;
	}

	/* Tabla de datos semanales */
	.data-table-wrapper {
		overflow-x: auto;
	}

	.weekly-data-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 9px;
	}

	.weekly-data-table th,
	.weekly-data-table td {
		padding: 2px 5px;
		text-align: center;
		color: #2D4B95;
		font-weight: 600;
		border-bottom: 1px solid #E3E8EF;
	}

	.weekly-data-table th {
		font-size: 8px;
		color: #6B7280;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.3px;
	}

	.weekly-data-table .row-label {
		text-align: left;
		font-weight: 700;
		padding-left: 0;
	}

	.weekly-data-table tbody tr.last-row td {
		border-bottom: none;
	}

	.section-inline-label {
		display: block;
		font-size: 7px;
		font-weight: 700;
		color: #9CA3AF;
		text-transform: uppercase;
		letter-spacing: 0.4px;
		line-height: 1;
		margin-bottom: 1px;
	}

	.weekly-data-table tbody tr.section-separator td {
		border-bottom: 2px solid #C8D3E8;
	}

	.toggle-table-btn {
		text-transform: none !important;
		font-size: 9px !important;
		font-weight: 600;
		letter-spacing: 0.3px;
		padding: 2px 8px !important;
		height: auto !important;
		min-height: 20px !important;
	}

	::v-deep .weekliy-chart canvas {
		border: none !important;
		box-shadow: none !important;
	}
</style>